import type { KubernetesDetailsStepView } from "~/areas/tasks/components/Task/Kubernetes/KubernetesDetailsLayout";
import { KubernetesAppliedManifestsLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Manifests/KubernetesAppliedManifestsLoadingSkeleton";
import { KubernetesSnapshotsLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Snapshot/KubernetesSnapshotsLoadingSkeleton";
type KubernetesDetailsLoadingSkeletonProps = {
    activeView: KubernetesDetailsStepView;
};
export const KubernetesDetailsLoadingSkeleton = (props: KubernetesDetailsLoadingSkeletonProps) => {
    switch (props.activeView) {
        case "Manifests":
            return <KubernetesAppliedManifestsLoadingSkeleton />;
        case "Snapshot":
            return <KubernetesSnapshotsLoadingSkeleton />;
    }
};
